import { render, staticRenderFns } from "./LightBox.vue?vue&type=template&id=776f37a7"
import script from "./LightBox.vue?vue&type=script&lang=js"
export * from "./LightBox.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776f37a7')) {
      api.createRecord('776f37a7', component.options)
    } else {
      api.reload('776f37a7', component.options)
    }
    module.hot.accept("./LightBox.vue?vue&type=template&id=776f37a7", function () {
      api.rerender('776f37a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/LightBox.vue"
export default component.exports